import { render, staticRenderFns } from "./StudentNotificationDetail.vue?vue&type=template&id=39b26db4"
import script from "../../services/notification/student-notification-detail.js?vue&type=script&lang=js&external"
export * from "../../services/notification/student-notification-detail.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/notification/student-notification-detail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports